import { defineComponent as _defineComponent } from 'vue'
import { ref, CSSProperties } from "vue";

import ValidatedTextInput from "@/components/validated_input/ValidatedTextInput.vue";
import ValidatedIntInput from "@/components/validated_input/ValidatedIntInput.vue";
import ValidatedTextAreaInput from "@/components/validated_input/ValidatedTextAreaInput.vue";
import {
  make_min_validator,
  make_max_validator,
  make_max_length_validator,
  make_min_length_validator,
  TextValidator,
  NumberValidator,
} from "@/new_validators";
import PairedInputs from "./PairedInputs.vue";

/**** ValidatedTextInput demo ****/

export default /*#__PURE__*/_defineComponent({
  __name: 'NewValidatedInputDemo',
  setup(__props) {

const val_1 = ref("ab");
const is_valid_1 = ref(true);

const has_even_number_of_chars: TextValidator = (input: string) => {
  if (input.length % 2 === 0) {
    return { is_valid: true };
  } else {
    return {
      is_valid: false,
      error_msg: "Input must contain an even number of characters",
    };
  }
};

const has_exclamation_point: TextValidator = (input: string) => {
  if (input.includes("!")) {
    return { is_valid: true };
  } else {
    return {
      is_valid: false,
      error_msg: "Input must contain an exclamation point (!)",
    };
  }
};

/**** ValidatedNumberInput demo ****/
const val_2 = ref(0);
const is_valid_2 = ref(true);

const even_number: NumberValidator = (input: number) => {
  if (input % 2 == 0) {
    return { is_valid: true };
  } else {
    return {
      is_valid: false,
      error_msg: "Input must be an even number",
    };
  }
};

/*** ValidatedTextArea demo ****/
const val_3 = ref("");
const is_valid_3 = ref(true);

const has_luigi_or_mario: TextValidator = (input: string) => {
  const text = input.toLowerCase();
  if (!(text.includes("luigi") || text.includes("mario"))) {
    return {
      is_valid: false,
      error_msg: "Does not contain Mario or Luigi. Proposterous!",
    };
  } else {
    return {
      is_valid: true,
    };
  }
};
const two_or_more_lines: TextValidator = (input: string) => {
  const num_lines = input.split("\n");
  if (num_lines.length >= 2) {
    return { is_valid: true };
  } else {
    return {
      is_valid: false,
      error_msg: "Input must two or more lines",
    };
  }
};

/*** PairedInput demo ****/
const val_4 = ref();
const is_valid_4 = ref();

return { __sfc: true,val_1, is_valid_1, has_even_number_of_chars, has_exclamation_point, val_2, is_valid_2, even_number, val_3, is_valid_3, has_luigi_or_mario, two_or_more_lines, val_4, is_valid_4, ValidatedTextInput, ValidatedIntInput, ValidatedTextAreaInput, make_min_validator, make_max_validator, make_max_length_validator, make_min_length_validator, PairedInputs }
}

})